import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { ApexHelpArticles } from './apex-help-articles';
import { CopilotSearchResults } from './copilot-search-results';

let showSuggestions = false;

const APEX_INPUT_SEARCH_BOX = '#searchquery';
const APEX_LINK = '.apex-suggestion-item';
const APEX_CLOSE_BUTTON = '#apex_drag_header .close_button';
export const renderApexHelpSuggestions = (suggestionData, suggestionContainer, renderSuggestionToHtml, hideSuggestionBox, i18n, logger, isNewLogo=false) => {
  const hideSuggestionBoxWithReset = () => {
    hideSuggestionBox();
    // reset after the pop up is closed
    showSuggestions = false;
  };
  ReactDOM.render(
    <div>
      <CopilotSearchResults
        i18n={i18n}
        hideSuggestionBox={hideSuggestionBoxWithReset}
        logger={logger}
        isNewLogo={isNewLogo}
      />
      <ApexHelpArticles
        suggestionData={suggestionData}
        renderSuggestionToHtml={renderSuggestionToHtml}
        logger={logger}
      />
    </div>,
    suggestionContainer
  );

  // show suggestions when typing in searchbox, hide on Enter
  $(APEX_INPUT_SEARCH_BOX).on('keyup', (e) => {
    showSuggestions = e.code !== 'Enter';
  });

  $(APEX_INPUT_SEARCH_BOX).on('keydown', (e) => {
    showSuggestions = e.code !== 'Enter';
  });


  $(document).on('click', APEX_LINK, () => {
    showSuggestions = false;
  });
  $(document).on('enter', APEX_LINK, () => {
    showSuggestions = false;
  });

  // reset after closing the pop up
  /* istanbul ignore next */
  $(APEX_CLOSE_BUTTON).on('click', () => {
    hideSuggestionBoxWithReset();
  });

  const isApexVisible = $('#apexHelpContainer').is(':visible');

  return {
    showSuggestions: isApexVisible && showSuggestions,
  };
};
